// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InboundEmailTestPopup_content_container__TlRhS {
  text-align: center;
}
.InboundEmailTestPopup_icon__tZRsF {
  color: var(--color-theme-blue);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/InboundEmailTestPopup/InboundEmailTestPopup.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".content_container {\n  text-align: center;\n}\n.icon {\n  color: var(--color-theme-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `InboundEmailTestPopup_content_container__TlRhS`,
	"icon": `InboundEmailTestPopup_icon__tZRsF`
};
export default ___CSS_LOADER_EXPORT___;
